

import { Button, Card, Col, Dropdown, Input, message, Modal, Row, Table, Tag } from "antd";
import network from "network/network";
import React, { useEffect, useRef, useState } from "react";  
import { CheckOutlined, CloseSquareOutlined, EditOutlined, EllipsisOutlined, QrcodeOutlined, SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import QrCodeModal from "components/Elements/QrCodeModal";

const WelcomeMessage = ({ changeTab }) => {
    const { t, i18n } = useTranslation();

    const qrCodeModalRef = useRef();
    const [informationData, setInformationData] = useState([]);
    const [isLoading, setIsLoading] = useState(true); 
    const [isUpdateModalOpen, setIsModalUpdateModalOpen] = useState(false);
    const [openModalDetail, setOpenModalDetail] = useState({
        firmNumber: "",
        selectedTemplateId: ""
    })
    const [templatesData, setTemplatesData] = useState([]);

    const [searchValue, setSearchValue] = useState('');

 
    useEffect(() => {
        selectInformationData();
        getAllTemplate();
    }, [])

    const getAllTemplate = async () => {
        var result = await network.get("/TemplateMessage/GetAllActiveTemplate", false);
        if (!result.isSuccess) {
            message.error(result.errorMessage);
        }
        else {
            if (!result.data.isSuccess) {
                message.error(result.data.errorMessage);
            } else {
                setTemplatesData(result.data.data);
            }
        }
        setIsLoading(false);
    }

    const selectInformationData = async () => {


        var result = await network.get("/admin/campaign/welcome-messages", null, false);

        if (result.isSuccess) {
            setInformationData(result.data);
        }


    }
 
    const WhatsAppTextParser = ({ text }) => {
        const regex = /(\*[^*]+\*|_[^_]+_)/g;

        return text.split("\n").map((line, lineIndex, array) => {
            const segments = line.split(regex);

            const parsedSegments = segments.map((segment, segmentIndex) => {
                if (segment.startsWith("*") && segment.endsWith("*")) {
                    return <strong key={segmentIndex}>{segment.slice(1, -1)}</strong>;
                } else if (segment.startsWith("_") && segment.endsWith("_")) {
                    return <em key={segmentIndex}>{segment.slice(1, -1)}</em>;
                } else {
                    return <React.Fragment key={segmentIndex}>{segment}</React.Fragment>;
                }
            });

            return (
                <React.Fragment key={lineIndex}>
                    {parsedSegments}
                    {lineIndex < array.length - 1 && <br />} {/* Son satırdan sonra <br /> koyma */}
                </React.Fragment>
            );
        });
    };

    const handleUpdateOpen = async (record) => {
        setOpenModalDetail({ firmNumber: record.firmNumber, selectedTemplateId:record.templateId })


        setIsModalUpdateModalOpen(true);


        const selectedTemplateId = record.templateId;
        if (selectedTemplateId) {
            const selectedTemplate = templatesData.find(
                (template) => template.id === selectedTemplateId
            );

            if (selectedTemplate) { 
                const result =  [
                    selectedTemplate,
                    ...templatesData.filter((template) => template.id !== selectedTemplateId),
                ];

                setTemplatesData(result);
            }
        }
    }


    const handleUpdateInformationOk = async (value) => {


        const params = {
            PhoneNumber: openModalDetail.firmNumber,
            TemplateId: openModalDetail.selectedTemplateId
        }
        var result = await network.post("/admin/campaign/save-welcome-message", params, false);

        if (result.isSuccess) {
            message.success(t("welcomeMessageSaved"));
            setIsModalUpdateModalOpen(false);
            selectInformationData();

        } else {
            message.error(t("welcomeMessageNotSaved"));
        }
    }

    const onOpenQrCode = (row) => {
        const link = `https://wa.me/${row.firmNumber}?text=${t("hello")}`
        const desc = `${row.eventDesc}`
        qrCodeModalRef.current.openModal(link, desc);
    }

    const handleStatusChange = async (value, welcomeMessageId) => {
        const params = {
            status: !value,
            welcomeMessageId: welcomeMessageId,
        }
        var result = await network.get("/admin/campaign/welcome-messages-status", params, false);

        if (result.isSuccess) {
            message.success(t("statusUpdateSuccess"));

            selectInformationData();

        } else {
            message.error(t("statusUpdateError"));
        }
    }

    const getTemplateTypeStyle = (type) => {
        switch (type) {
            case 'TEXT':
                return { backgroundColor: '#f7faff', color: '#0078D4', padding: '5px 10px', borderRadius: '5px' }; // Hafif mavi ton
            case 'IMAGE':
                return { backgroundColor: '#fff7e6', color: '#fa8c16', padding: '5px 10px', borderRadius: '5px' }; // Turuncu ton
            case 'VIDEO':
                return { backgroundColor: '#fcefe6', color: '#d4380d', padding: '5px 10px', borderRadius: '5px' }; // Kırmızımsı ton
            default:
                return { backgroundColor: '#f0f0f0', color: '#595959', padding: '5px 10px', borderRadius: '5px' }; // Nötr gri
        }
    };
    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchValue(value);
    }

    const getItems = (record) => [
        {
            label: (<span >{t('edit')}</span>),
            key: '1',
            icon: <EditOutlined />,
            onClick: () => handleUpdateOpen(record)
        },
        {
            label: (<span >{!record.status ? t('active') : t('inactive')}</span>),
            key: '2',
            icon: !record.status ? <CheckOutlined /> : <CloseSquareOutlined />,
            onClick: () => handleStatusChange(record.status, record.id)
        }
    ]
    const tableColumns = [
        {
            title: t("phoneNumber"),
            dataIndex: "firmNumber",
            key: "firmNumber",
        },
        {
            title: t("content"),
            dataIndex: "içerik",
            render: (_, record) => (
                <div className="markdown-container" style={{
                    backgroundColor: "#DCF8C6",
                    borderRadius: "12px",
                    padding: "10px 15px",
                    color: "#111111",
                    fontWeight: 400,
                    maxWidth: "75%",
                    wordWrap: "break-word",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                    display: "inline-block",
                    margin: "5px 0",
                    alignSelf: "flex-end",
                }}>  
                    <WhatsAppTextParser text={getTemplateFromId(record)} />
                </div>
            )
        },
        {
            title: t('qrCodeCol'),
            dataIndex: "",
            render: (_, record) => (
                <div className="row-align-center">
                    <Button variant="text" style={{
                        boxShadow: "none",
                        border: 0
                    }} onClick={() => onOpenQrCode(record)} icon={<QrcodeOutlined style={{ fontSize: "25px" }} />}>

                    </Button>
                </div>

            )
        },
        {
            title: t("status"),
            dataIndex: "status",
            key: "status",
            render: (_, record) => record.templateId && record.templateId?.length > 0 ? (
                <div style={{ width: "200px" }} >
                    <Tag color={record.status === true ? "green" : "red"}>
                        {record.status === true ? t("active") : t("inactive")}
                    </Tag>
                </div>
            ) : null
        },
        {
            title: t('actions'),
            dataIndex: "",
            render: (_, record) => (
                <div className="row-align-center">
                    <Dropdown menu={{ items: getItems(record) }} trigger={['click']}>
                        <div className="ellipsis-dropdown" style={{ cursor: 'pointer' }}>
                            <EllipsisOutlined />
                        </div>
                    </Dropdown>
                </div>

            )
        }



    ]

    const templateColumns = [
        {
            key: 1,
            title: t('templateName'),
            dataIndex: 'elementName',
            width: 100,
            colSpan: 1,
            render: (_, record) => (
                <div style={styles.cell}>
                    <div style={styles.text}>{record.elementName}</div>
                </div>
            )
        },
        {
            key: 2,
            title: t('templateType'),
            dataIndex: 'templateType',
            width: 100,
            render: (_, record) => {
                // Template tipine göre renklendirme
                const typeStyle = getTemplateTypeStyle(record.templateType);
                return (
                    <div style={styles.cell}>
                        <div style={{ ...styles.text, ...typeStyle }}>{record.templateType}</div>
                    </div>
                );
            }
        },
        {
            key: 2,
            title: <div style={{ textAlign: 'left', marginLeft: 8 }}>{t('messageContent')}</div>,
            dataIndex: 'data',
            width: 350,
            render: (_, record) => (
                <div style={styles.cell}>
                    <div style={{
                        backgroundColor: "#DCF8C6", // Gönderilen mesajlar için WhatsApp yeşili
                        borderRadius: "12px", // Yuvarlak köşeler
                        padding: "10px 15px", // Mesaj içeriği için boşluk
                        color: "#111111", // Yazı rengi
                        fontWeight: 400, // Yazı kalınlığı
                        maxWidth: "80%", // Mesajın genişliği
                        wordWrap: "break-word", // Uzun mesajları kır
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // Hafif gölge
                        display: "inline-block", // İçeriği bir satırda tut
                        margin: "5px 0", // Mesaj balonları arası boşluk
                        alignSelf: "flex-end", // Gönderilen mesajı sağa hizala
                    }}>
                        {record.data}
                    </div>
                </div>
            )
        },
    ]

    const getTemplateListByFilter = () => {

        if (searchValue.length > 0) {
            return templatesData.filter((template) =>
                template.elementName.toLowerCase().includes(searchValue)
            )
        } else {
            return templatesData;
        }
    }

    const getTemplateFromId = (record) => {
        const template = templatesData.find(w => w.id == record.templateId);


        if (template) {
            return template.data;
        } else {
            return "--";
        }
    }

 

    return (
        <div>

            <Card loading={isLoading}>

                <Table
                    columns={tableColumns}
                    dataSource={informationData}
                />
            </Card>

            <Modal
                open={isUpdateModalOpen}
                closeIcon={true}
                closable={false}
                width={"fit-content"}
                onCancel={() => {
                    setIsModalUpdateModalOpen(false); 
                }}
                onOk={handleUpdateInformationOk}
           
            >
                <div className="mt-2" style={{
                    overflowY: "scroll",
                    maxHeight: 800,
                    minWidth: 1200
                }}>
                    <Row>
                        <Col span={9} className=' mt-3 pl-3'>
                            <div className="mr-md-3 ">
                                <Input placeholder={t("searchTemplate")} onChange={handleSearch} prefix={<SearchOutlined />} />
                            </div>
                        </Col>
                    </Row>
                    <div className="table-responsive  p-3">
                        <Table
                            pagination={{ pageSize: 6 }}
                            columns={templateColumns}
                            dataSource={getTemplateListByFilter()}
                            rowKey='id'
                            // rowSelection={rowSelection}
                            rowSelection={
                                {
                                    type: 'radio',
                                    columnWidth: 48,
                                    defaultSelectedRowKeys: [openModalDetail.selectedTemplateId],
                                    selectedRowKeys: [openModalDetail.selectedTemplateId],
                                    onSelect: (record) => {
                                        try {
                                            setOpenModalDetail({
                                                ...openModalDetail,
                                                selectedTemplateId: record.id
                                            });
                                        } catch (error) {
                                            alert(error);
                                        }


                                    }
                                }
                            }
                        />
                    </div>
                </div>
            </Modal>

            <QrCodeModal ref={qrCodeModalRef} />
        </div>
    )
}


const styles = {
    table: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        marginTop: '20px',
    },
    cell: {
        padding: '10px',
        textAlign: 'left',
        fontSize: '14px',
        color: '#333',
    },
    cell2: {
        padding: '10px',
        textAlign: 'left',
        fontSize: '14px',
        color: '#333',
    },
    text: {
        fontWeight: '500',
    },
    header: {
        backgroundColor: '#f5f5f5',
        fontWeight: '600',
        color: '#1890ff',
    },
    radioButton: {
        display: 'flex',
        justifyContent: 'center',
    },
    // Row hover style
    rowHover: {
        backgroundColor: '#f0faff',
    },
    selectedRow: {
        backgroundColor: '#e6f7ff',
    },
    // Header styles
    headerTitle: {
        backgroundColor: '#1890ff',
        color: '#fff',
        padding: '12px',
        fontWeight: 'bold',
        fontSize: '16px',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
    },
};

export default WelcomeMessage